
import { Component, Prop, Vue } from "nuxt-property-decorator";
@Component
export default class PageJumpNavigationMolecule extends Vue {
  private static nextId = 0;
  @Prop({ default: "default" }) variant!: string;
  @Prop() headline!: string;
  @Prop() scrollDistance!: string | number;
  @Prop({ default: false }) collapsibleMobile!: boolean;
  @Prop({ required: true })
  menuItems!: Array<{
    name: string;
    title: string;
    href: { path?: string; hash: string };
  }>;

  mobileOpen = false;
  mountedOnce = false;
  windowWidth = 0;
  uniqueId = 0;

  onResize = () => {
    this.windowWidth = window.innerWidth;
  };

  created() {
    this.uniqueId = PageJumpNavigationMolecule.nextId++;
  }

  mounted() {
    this.mountedOnce = true;
    this.windowWidth = window.innerWidth;
    window.addEventListener("resize", this.onResize, { passive: true });
  }

  beforeDestroy() {
    window.removeEventListener("resize", this.onResize);
  }

  get showMobileIcon(): boolean {
    // Only show icon if collapsibleMobile is true AND screen width <= 960px
    return (
      this.collapsibleMobile && this.mountedOnce && this.windowWidth <= 960
    );
  }

  get listId(): string {
    return `page-jump-nav-${this.uniqueId}`;
  }

  get ulClasses(): string {
    if (!this.collapsibleMobile) return "";
    return `is--mobile-open-${this.mobileOpen}`;
  }

  get navStyle(): Record<string, string> {
    if (this.scrollDistance === undefined || this.scrollDistance === null) {
      return {};
    }
    return { height: `${this.scrollDistance}%` };
  }

  handleToggle(): void {
    if (!this.collapsibleMobile) return;
    this.mobileOpen = !this.mobileOpen;
  }

  onItemClick(hash: string, event?: MouseEvent): void {
    event?.preventDefault();
    if (this.collapsibleMobile) {
      this.mobileOpen = false;
    }
    const id = hash.startsWith("#") ? hash.slice(1) : hash;
    const target = document.getElementById(id);
    if (target) {
      target.scrollIntoView({ behavior: "smooth" });
      window.history.replaceState(null, "", hash);
    }
  }
}
